import React, { Component } from 'react'
import { Input, InputNumeric } from 'mdbreact';
import  axios  from "axios";
import  Results  from "../Results/Results";
require('dotenv').config()


export default class myInput extends Component {
  state = {
    searchText: '',
    amountRadio: 15,
    apiURL: 'https://pixabay.com/api',
    apiKEY: process.env.REACT_APP_IMAGE_API_KEY,
    images: [],
  }

  onTextChange = (e) => {
    this.setState({[e.target.name]: e.target.value}, () => {
      axios.get(`${this.state.apiURL}/?key=${this.state.apiKEY}&q=${this.state.searchText}&per_page=${this.state.amountRadio}&orientation=horizontal`)
      .then(res => this.setState({images: res.data.hits}))
      .catch(err => console.log('An error has occured' + err));
    });
  }

  valueHandler = (value) => {
    this.setState({
      amountRadio: value,
      loaded: true
    })
  }

  changeLoaded = () => {
    this.setState({
      loaded: true
    })
  }
  render() {
    return (
      <div className="container-fluid">
        <Input
        name="searchText"
        label="What's on your mind?"
        icon="image"
        value={this.state.searchText}
        onChange={this.onTextChange}
        onSubmit={this.changeLoaded}
        />
        <InputNumeric
        placeholder={'Enter the amount of pictures you wish to see'}
        getValue = {this.valueHandler}
        min={3}
        max={200}/>
      <br/>
      {this.state.loaded ? (<Results images = {this.state.images}/>) : null }
      </div>
    )
  }
}
